import { cancerscreenSampleFieldSet } from '@app/modules/service-data/components/sample/sample-dialog/field-sets/cancerscreen.field-set';
import { carrierSampleFieldSet } from '@app/modules/service-data/components/sample/sample-dialog/field-sets/carrier.field-set';
import { monoSampleFieldSet } from '@app/modules/service-data/components/sample/sample-dialog/field-sets/mono.field-set';
import { negSingleCarrierSampleFieldSet } from '@app/modules/service-data/components/sample/sample-dialog/field-sets/neg-single-carrier.field-set';
import { niptSampleFieldSet } from '@app/modules/service-data/components/sample/sample-dialog/field-sets/nipt.field-set';
import { nipptSampleFieldSet } from '@app/modules/service-data/components/sample/sample-dialog/field-sets/nippt.field-set';
import { paternitySampleFieldSet } from '@app/modules/service-data/components/sample/sample-dialog/field-sets/paternity.field-set';
import { rhdSampleFieldSet } from '@app/modules/service-data/components/sample/sample-dialog/field-sets/rh.field-set';
import { venisafeSampleFieldSet } from '@app/modules/service-data/components/sample/sample-dialog/field-sets/venisafe.field-set';
import { DataInputType } from '@core/core.types';

export const sampleFieldConfiguration: {
  [groupKey: string]: string[];
} = {
  [DataInputType.NIPT]: niptSampleFieldSet,
  [DataInputType.NIPPT]: nipptSampleFieldSet,
  [DataInputType.MONO]: monoSampleFieldSet,
  [DataInputType.RH]: rhdSampleFieldSet,
  [DataInputType.CARRIER]: carrierSampleFieldSet,
  [DataInputType.CANCERSCREEN]: cancerscreenSampleFieldSet,
  [DataInputType.GALLERI]: [],
  [DataInputType.PATERNITY]: paternitySampleFieldSet,
  [DataInputType.NEGSINGLECARRIER]: negSingleCarrierSampleFieldSet,
  [DataInputType.VENISAFEMATERNA]: venisafeSampleFieldSet,
  [DataInputType.VENISAFE]: venisafeSampleFieldSet,
  [DataInputType.OTHER]: [],
};
